var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkText"},[_c('div',{staticClass:"text"},[_vm._v("\n\t\t"+_vm._s(_vm.showText)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }